import React, { Component } from 'react'
import Icon from '../icon'
import { TimeLineIcons } from '../icons'
import './timelinesegment.scss'

const LINE_TYPES = {
  None: -1,
  DoubleSolid: 0,
  DoubleDashed: 1,
  SingleSolid: 2,
  SingleDashed: 3
}

const POINT_TYPES = {
  None: -1,
  Default: 0,
  Dot_Gray: 1,
  Intersection: 2,
  Ok_Green: 3,
  Exclamation_Red: 4
}

/**
 * Renders a vertical time line segment for one "step" in a timeline. Multiple parallel lines are supported.
 * Note: Any width assigned to this component must be a multiple of 20. (Each line takes exactly 20 pixels in width)
 * Vertically, the component will fill up to the edges, to allow stacking them to produce continous time lines.
 */
class TimeLineSegment extends Component {

  getLineTypeClass (lineType) {
    switch (lineType) {
      case LINE_TYPES.SingleSolid:
        return 'linesegment single-solid'
      case LINE_TYPES.DoubleSolid:
        return 'linesegment double-solid'
      case LINE_TYPES.SingleDashed:
        return 'linesegment single-dashed'
      case LINE_TYPES.DoubleDashed:
        return 'linesegment double-dashed'
    }
    return 'linesegment none'
  }

  renderTopLines (lines) {
    return (
      <div className='element-timelinesegment__lines__top'>
        {lines.map((x, i) => { return this.renderLineSegment(x.LineTypeBefore, i) })}
      </div>
    )
  }

  renderBottomLines (lines) {
    return (
      <div className='element-timelinesegment__lines__bottom'>
        {lines.map((x, i) => { return this.renderLineSegment(x.LineTypeAfter, i) })}
      </div>
    )
  }

  renderLineSegment (lineType, index) {
    return (
      <div key={index} className='segment-center'>
        <div className={this.getLineTypeClass(lineType)} />
      </div>
    )
  }

  renderLineDots (lines) {
    return (
      <div className='element-timelinesegment__lines__center'>
        {lines.map((x, i) => { return this.renderDotSegment(x.LineDotType, i) })}
      </div>
    )
  }

  renderDotSegment (dotType, index) {
    // Html for different point types.
    let blank = <div key={index} className='segment-center' />

    let dotGray = (
      <div key={index} className='segment-center'>
        <div className='dotsegment dot_gray' />
      </div>
    )

    let intersection = (
      <div key={index} className='segment-center'>
        <div className='dotsegment intersection' />
      </div>
    )

    let okGreen = (
      <div key={index} className='segment-center'>
        <div className='dotsegment icon'>
          <Icon icon={TimeLineIcons.Ok_Green} size='t' />
        </div>
      </div>
    )

    let exclamationRed = (
      <div key={index} className='segment-center'>
        <div className='dotsegment icon'>
          <Icon icon={TimeLineIcons.Exclamation_Red} size='t' />
        </div>
      </div>
    )
    switch (dotType) {
      case POINT_TYPES.Dot_Gray:
        return dotGray
      case POINT_TYPES.Intersection:
        return intersection
      case POINT_TYPES.Ok_Green:
        return okGreen
      case POINT_TYPES.Exclamation_Red:
        return exclamationRed
    }
    return blank
  }

  renderActive (lines) {
    const renderActiveSegment = (index) => {
      // First index is where we put the active dot and line. We don't support the active dot in other segments.
      let activeDotWithLine = (
        <div key={'active_' + index} className='active-span'>
          <div className='active-dot' />
          <div className='active-line' />
        </div>
      )
      if (index === 0) {
        return activeDotWithLine
      }
      return null
    }

    return (
      <div className='element-timelinesegment__lines__center'>
        {lines.map((x, i) => { return renderActiveSegment(i) })}
      </div>
    )
  }

  render () {
    let inlineStyle = { gridTemplateRows: this.props.topHeight + ' 0px ' + this.props.bottomHeight }
    return (
      <div className='element-timelinesegment'>
        <div className='element-timelinesegment__lines' style={inlineStyle}>
          {this.renderTopLines(this.props.lines)}
          {this.props.active ? this.renderActive(this.props.lines) : this.renderLineDots(this.props.lines)}
          {this.renderBottomLines(this.props.lines)}
        </div>
      </div>
    )
  }
}

TimeLineSegment.defaultProps = {
  topHeight: '1fr',       // Height of top in any unit   (Use these to align center to content rendered next to this component)
  bottomHeight: '1fr',    // Height of bottom in any unit
  active: true,           // True to render active line with dot, overrides any dot type
  lines: [{
    LineTypeAfter: LINE_TYPES.SingleSolid,
    LineTypeBefore: LINE_TYPES.SingleSolid,
    LineDotType: POINT_TYPES.Dot_Gray
  }, {
    LineTypeAfter: LINE_TYPES.DoubleSolid,
    LineTypeBefore: LINE_TYPES.DoubleSolid,
    LineDotType: POINT_TYPES.Intersection
  }, {
    LineTypeAfter: LINE_TYPES.SingleDashed,
    LineTypeBefore: LINE_TYPES.SingleDashed,
    LineDotType: POINT_TYPES.Ok_Green
  }, {
    LineTypeAfter: LINE_TYPES.DoubleDashed,
    LineTypeBefore: LINE_TYPES.DoubleDashed,
    LineDotType: POINT_TYPES.Exclamation_Red
  }]
}

export default TimeLineSegment



// WEBPACK FOOTER //
// ./src/app/shared/elements/timeLineSegment/index.js